var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "classroomHeader" },
    [
      _c(
        "el-tooltip",
        { attrs: { content: "返回", placement: "bottom", effect: "light" } },
        [
          _c("el-button", {
            attrs: { icon: "el-icon-arrow-left", circle: "" },
            on: { click: _vm.goBack },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("img", { staticClass: "logo", attrs: { src: _vm.logo, alt: "" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "funRegionBox" },
        [
          _vm.lessonType == "scratch" || _vm.lessonType == "python"
            ? _c(
                "el-button-group",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "" },
                      on: {
                        click: function ($event) {
                          return _vm.changeTab("board")
                        },
                      },
                    },
                    [_vm._v("课件")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", round: "" },
                      on: {
                        click: function ($event) {
                          return _vm.changeTab("editor")
                        },
                      },
                    },
                    [_vm._v("编程")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rightBox" },
        [
          _c("div", { staticClass: "timeAnddownClass" }, [
            _c("span", [
              _vm._v(
                _vm._s(`已上课 ${_vm.hours}：${_vm.minute}：${_vm.second}`)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("svg-icon", {
            attrs: { "icon-class": "settings" },
            on: {
              click: function ($event) {
                return _vm.setSettingVisible(true)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("SettingDialog"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/classroom1/components/classroomHeader.vue?vue&type=template&id=2121188e&
// module id = null
// module chunks = 